module.exports = __webpack_public_path__ + "static/media/c-banner.d5963837.jpg";